class Controller {
  constructor($mdDialog, $injector, Events, ride) {
    this.$mdDialog = $mdDialog;
    this.loading = false;
    this.Ride = $injector.get("Ride");
    this.Events = Events;
    this.confirmEvent = Events.getUpdateEvent("confirmEventTransfer");
    this.errorEvent = Events.eventsType.onShowErrorNotification;
    this.successEvent = Events.eventsType.onShowSuccessNotification;
    this.ride = ride;
    this.RideTransforms = $injector.get("RideTransforms");
  }
  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));
  }

  confirm() {
    this.$mdDialog.hide({ removeMapping: true });
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/unAssignCaptain/removeSupplierDialog/removeSupplierDialog.controller.js